/**
 * Created by kevinqueeney on 09/09/2015.
 */
angular.module('qkr.inventory').factory('variantCoefficientHelperService', [function() {
    const isolateVariantSetSummaryOptionCoefficientForVariant = function(variantSetSummary, preceedingVariantSetSummaries, variantCoefficientValue) {
        const coefficient = variantCoefficientValue;
        let isolatedCoefficient = coefficient;

        // Isolate from preceeding coefficients
        for (let i = 0; i < preceedingVariantSetSummaries.length; i++) {
            const summaryCoefficient = preceedingVariantSetSummaries[i].summaryCoefficient;
            isolatedCoefficient = coefficient % (Math.floor(coefficient / summaryCoefficient) * summaryCoefficient);
        }

        isolatedCoefficient = (Math.floor(isolatedCoefficient / variantSetSummary.summaryCoefficient) * variantSetSummary.summaryCoefficient);

        return isolatedCoefficient;
    };

    return {
        isolateVariantSetSummaryOptionCoefficientForVariant(variantSetSummary, preceedingVariantSetSummaries, variantCoefficientValue) {
            return isolateVariantSetSummaryOptionCoefficientForVariant(variantSetSummary, preceedingVariantSetSummaries, variantCoefficientValue);
        }
    };
}]);



// WEBPACK FOOTER //
// ./src/inventory/services/variantCoefficientHelper.services.js